t = require('views/internal/teacup-with-helpers')('member_application')

module.exports = ->
  t.div '.member-applications-list-item-details', ->

    t.h5 ->
      t.mustacheBlock 'identifier', ->
        t.text t.mustacheVar('identifier')
      t.mustacheBlockInverted 'identifier', ->
        t.format 'unknown-application'

    t.ul '.quiet', ->
      t.mustacheBlock 'permissions', ->
        t.li ->
          t.text t.mustacheVar('.')

    t.p '.quiet', ->
      t.format 'approved-dateapproved', { dateApproved: t.mustacheVar('dateApproved') }
      t.br()

      t.mustacheBlock 'neverExpires', ->
        t.format 'never-expires'
      t.mustacheBlockInverted 'neverExpires', ->
        t.format 'expires-dateexpires', { dateExpires: t.mustacheVar('dateExpires') }

  t.div '.member-applications-list-item-button', ->
    t.input '.js-revoke', { type: 'button', value: t.l('revoke') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_application.coffee